import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

type ProShellFilterRailContextValue = {
  mountNode: HTMLElement | null;
  setMountNode: (el: HTMLElement | null) => void;
};

const ProShellFilterRailContext = createContext<ProShellFilterRailContextValue | null>(null);

export function ProShellFilterRailProvider({ children }: { children: React.ReactNode }) {
  const [mountNode, setMountNodeState] = useState<HTMLElement | null>(null);
  const setMountNode = useCallback((el: HTMLElement | null) => {
    setMountNodeState(el);
  }, []);
  const value = useMemo(() => ({ mountNode, setMountNode }), [mountNode, setMountNode]);
  return <ProShellFilterRailContext.Provider value={value}>{children}</ProShellFilterRailContext.Provider>;
}

/** Portal target for tool filters when MMEC Pro shell right rail is mounted. */
export function useProShellFilterRailMount(): HTMLElement | null {
  return useContext(ProShellFilterRailContext)?.mountNode ?? null;
}

export function useProShellFilterRailSetMount(): (el: HTMLElement | null) => void {
  return useContext(ProShellFilterRailContext)?.setMountNode ?? (() => {});
}
